/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// Former goog.module ID: Blockly.IDraggable

import type {IDeletable} from './i_deletable.js';

/**
 * The interface for an object that can be dragged.
 */
export interface IDraggable extends IDeletable {}
